import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '../../tool';
import {reduxTemplateConfig, templateConfig} from './config';
import {getSearchMap} from "../common/wizCharts/utils";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;

class PermissionSettingManager extends WizContainer {
  componentName = 'PermissionSettingManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _componentDidMount() {

  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PermissionSettingManager);
